const DEFAULT_DATA = {
    hero: {
        badge: 'ZAHMETSİZ ISO 27001',
        badge_en: 'EFFORTLESS ISO 27001',
        title: 'Basit Hizmet Uyumluluğu',
        title_en: 'Simple Service Compliance',
        description:
            'Karmaşık süreçleri tek platformdan kolayca yönetin. RUZY ile üçüncü taraf ve dahili hizmetlerinizi otomatize edin, iş yükünüzü hafifletirken güvenlik standartlarınızı zahmetsizce en üst seviyeye taşıyın.',
        description_en:
            'Easily manage complex processes from a single platform. Automate your third-party and internal services with RUZY, effortlessy taking your security standards to the highest level while reducing your workload.',
        primaryButtonText: 'Hızlı Başlangıç Yap',
        primaryButtonText_en: 'Quick Start',
        secondaryButtonText: 'Kolay Kullanım Rehberi',
        secondaryButtonText_en: 'Easy Use Guide',
        complianceRate: '98',
        complianceTrend: 'up', 
        image: null,
    },
    stats: {
        stats: [
            {
                label: 'TEK PANELEN YÖNETİM',
                label_en: 'SINGLE PANEL MANAGEMENT',
                value: '124',
                value_en: '124',
                icon: 'folder', 
                subText: 'Hizmet envanteri aktif',
                subText_en: 'Service inventory active',
            },
            {
                label: 'RİSKLER KONTROL ALTINDA',
                label_en: 'RISKS UNDER CONTROL',
                value: 'Güvenli',
                value_en: 'Secure',
                icon: 'thumb_up', 
                subText: 'Kritik risk saptanmadı',
                subText_en: 'No critical risks detected',
            },
            {
                label: 'OTOMATİK HATIRLATMALAR AKTİF',
                label_en: 'AUTO REMINDERS ACTIVE',
                value: '08',
                value_en: '08',
                icon: 'notifications', 
                subText: 'Bekleyen görevler',
                subText_en: 'Pending tasks',
            },
        ],
    },
    features: {
        Title: 'Yalın Hizmet Yönetimi',
        Title_en: 'Lean Service Management',
        Description:
            'Hizmet süreçlerinizi sadeleştirerek ISO 27001 uyumluluğunu en pratik yoldan sağlayın.',
        Description_en:
            'Ensure ISO 27001 compliance in the most practical way by simplifying your service processes.',
        cards: [
            {
                icon: 'inventory_2',
                Title: 'Pratik Varlık Takibi',
                title_en: 'Practical Asset Tracking',
                Description:
                    'Tüm hizmetlerinizi tek bir basit listede toplayın. Karmaşık Excel dosyaları yerine otomatik envanterin tadını çıkarın.',
                description_en:
                    'Gather all your services in one simple list. Enjoy automatic inventory instead of complex Excel files.',
                bullets: [
                    { title: 'Hızlı Listeleme', title_en: 'Quick Listing' },
                    { title: 'Otomatik Envanter', title_en: 'Automated Inventory' },
                ],
            },
            {
                icon: 'analytics',
                Title: 'Otomatik Risk Analizi',
                title_en: 'Automated Risk Analysis',
                Description:
                    'Risk değerlendirmelerini manuel yapmakla vakit kaybetmeyin. Akıllı algoritmalarımızla sonuçlara saniyeler içinde ulaşın.',
                description_en:
                    'Don\'t waste time doing risk assessments manually. Reach results in seconds with our smart algorithms.',
                bullets: [
                    { title: 'Akıllı Algoritma', title_en: 'Smart Algorithm' },
                    { title: 'Saniyeler İçinde Sonuç', title_en: 'Results in Seconds' },
                ],
            },
            {
                icon: 'verified',
                Title: 'Zahmetsiz Uyum İzleme',
                title_en: 'Effortless Compliance Monitoring',
                Description:
                    'SLA ve güvenlik kontrollerini arka planda takip edin. Denetim günlerinde stres yaşamadan kanıtlarınızı hazır tutun.',
                description_en:
                    'Track SLA and security controls in the background. Keep your evidence ready without stress on audit days.',
                bullets: [
                    { title: 'SLA Takibi', title_en: 'SLA Tracking' },
                    { title: 'Stressiz Denetim', title_en: 'Stress-free Audit' },
                ],
            },
        ],
    },
    cta: {
        Title: 'Uyumluluğu Kolaylaştırmaya Hazır Mısınız?',
        Title_en: 'Ready to Simplify Compliance?',
        Description:
            'Sadece bir yazılım değil, iş yükünüzü azaltan bir asistan. ISO 27001 yolculuğunuzu bugün sadeleştirin.',
        Description_en:
            'Not just software, but an assistant that reduces your workload. Simplify your ISO 27001 journey today.',
        primaryButtonText: 'Demo ile Kolaylığı Keşfet',
        primaryButtonText_en: 'Discover Ease with Demo',
        secondaryButtonText: 'Bize Ulaşın',
        secondaryButtonText_en: 'Contact Us',
    },
};

export default DEFAULT_DATA;